"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _text = _interopRequireDefault(require("@ux/text"));
var _base = require("@site/pattern-library-utils/base.functions");
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _link = _interopRequireDefault(require("../../elements/buttons/link"));
var _motionFunctions = require("@site/pattern-library-core/motion-functions");
var _image = require("@site/pattern-library-core/image");
var _breakpoints = require("@site/pattern-library-utils/breakpoints");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const CardContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "CardContainer",
  class: "pl-c17zap4u"
});
const Content = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "Content",
  class: "pl-c16u2wpt"
});
const Image = /*#__PURE__*/(0, _react2.styled)(_image.LazyImage)({
  name: "Image",
  class: "pl-i1se6kkj"
});
const ButtonWrapper = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "ButtonWrapper",
  class: "pl-bnnhi8c"
});
const OverlayAnchor = /*#__PURE__*/(0, _react2.styled)("a")({
  name: "OverlayAnchor",
  class: "pl-o84ayqm"
});

/**
 * QuickLearnCard Component.
 *
 * @param {Object} props React props
 * @param {string} props.id Unique identifier for the card
 * @param {string} props._name Unique identifier for the card
 * @param {string} props.eyebrow Eyebrow text
 * @param {string} props.heading Heading text
 * @param {Object} props.image Image object
 * @param {string} props.className Additional classes
 * @param {Function} props.handleClick Click handler
 * @param {Object} props.cta Call to action object
 * @returns {React.ReactElement} QuickLearnCard Component
 * @public
 */
const QuickLearnCard = /*#__PURE__*/(0, _react.forwardRef)(
// eslint-disable-next-line complexity
({
  id,
  _name,
  eyebrow,
  eyebrowTag = 'h2',
  heading,
  headlineTag = 'h3',
  image = {},
  cta,
  className = '',
  handleClick,
  invert,
  ...rest
}, ref) => {
  const isAnchor = !!cta?.href;
  const {
    url,
    altText,
    height,
    width
  } = image;
  const isAnchorAttributes = isAnchor ? {
    href: cta.href
  } : {
    onClick: handleClick
  };
  const trackingProps = _patternLibraryUtils.tracking.create(`card-overlay-anchor-${_name}`, true, true, {
    item_tracking_code: _name
  });
  const handlePlusCtaClick = e => {
    if (handleClick) {
      handleClick(e);
    }
  };
  const HeadlineTag = _text.default[headlineTag];
  const EyebrowTag = _text.default[eyebrowTag];
  return /*#__PURE__*/_react.default.createElement(CardContainer, {
    ref: ref,
    className: `quick-learn-card ${className}`,
    "data-partial": invert ? 'dark1' : ''
  }, cta && /*#__PURE__*/_react.default.createElement(OverlayAnchor, (0, _extends2.default)({
    id: `id-${id}`,
    "data-cy": "card-overlay-anchor",
    role: "link",
    "aria-label": isAnchor ? cta.ariaLabel : eyebrow
  }, isAnchorAttributes, trackingProps)), (heading || eyebrow) && /*#__PURE__*/_react.default.createElement(Content, null, eyebrow && /*#__PURE__*/_react.default.createElement(EyebrowTag, {
    as: "title",
    className: "card-eyebrow",
    size: -1,
    text: eyebrow
  }), heading && /*#__PURE__*/_react.default.createElement(HeadlineTag, {
    as: "title",
    className: "card-heading",
    size: 2,
    text: heading
  })), url && /*#__PURE__*/_react.default.createElement(Image, {
    dataCy: "card-image",
    url: url,
    altText: altText,
    height: height,
    width: width
  }), cta && /*#__PURE__*/_react.default.createElement(ButtonWrapper, {
    "data-partial": invert ? 'light1' : 'dark1'
  }, /*#__PURE__*/_react.default.createElement(_link.default, (0, _extends2.default)({
    id: `id-${id}`,
    _name: _name,
    design: "inline",
    dataCy: "card-action",
    "aria-label": isAnchor ? cta.ariaLabel : eyebrow,
    icon: isAnchor ? 'arrow-right' : 'plus',
    trackingCustomProperties: {
      item_tracking_code: _name
    }
  }, isAnchor ? {
    href: cta.href
  } : {
    onClick: handlePlusCtaClick
  }, rest))));
});
var _default = exports.default = QuickLearnCard;
QuickLearnCard.propTypes = {
  id: _propTypes.default.string,
  _name: _propTypes.default.string,
  eyebrow: _propTypes.default.string,
  eyebrowTag: _propTypes.default.oneOf(['h1', 'h2', 'h3', 'p']),
  heading: _propTypes.default.string,
  headlineTag: _propTypes.default.oneOf(['h1', 'h2', 'h3', 'h4', 'p']),
  image: _propTypes.default.shape(_image.imgPropShape),
  className: _propTypes.default.string,
  handleClick: _propTypes.default.func,
  cta: _propTypes.default.object,
  invert: _propTypes.default.bool
};